<template>
  <v-application v-if="access.inv_transfer_orders">
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="transfer"
          to="/inventory/transfer"
          v-bind:headers="headers"
          v-bind:data="transfers"
          no-delete
          view
          v-bind:num-pages="transfers_total"
          v-model="transfers_page"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          v-bind:add_button_name="'add_transfer'"
          showSearch
          InventoryTransfer
          v-bind:search_text="search_text"
          v-bind:getData="update_transfers"
          v-bind:searchActivate="
            (state) => {
              search_text = state;
            }
          "
          v-bind:setText="
            (text) => {
              search = text;
            }
          "
        >
          <template #top>
            <v-combobox
              v-model="status"
              label="Status"
              v-bind:items="statusses"
              hide-details
              item-text="name"
              class="mx-1"
            />
            <v-combobox
              v-model="sourse_store"
              label="Source store"
              v-bind:items="stores"
              hide-details
              item-text="name"
              class="mx-1"
            />
            <v-combobox
              v-model="destination_store"
              label="Destination store"
              v-bind:items="stores"
              hide-details
              item-text="name"
              class="mx-1"
            />
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
import Transfers from "../../mixins/inventory/transfer";
export default {
  name: "Transfer",
  mixins: [Services, Transfers],
  data: () => ({
    headers: [
      { text: "Transfer order", value: "p_order" },
      { text: "Date", value: "date" },
      { text: "Received", value: "expected_on" },
      { text: "Source store", value: "first_service_name" },
      { text: "Destination store", value: "second_service_name" },
      { text: "Status", value: "status" },
      { text: "Quantity", value: "quality", left: true },
    ],
    data: [],
    search_text: false,
    search: "",
  }),
  methods: {
    changePagination(page) {
      this.transfers_page = page;
      this.update_transfers();
    },
  },
  mounted() {
    this.headers = [
      { text: this.$t("transfer_order"), value: "p_order", available: true },
      { text: this.$t("date"), value: "date", available: true },
      {
        text: this.$t("source_store"),
        value: "first_service_name",
        available: true,
      },
      {
        text: this.$t("destination_store"),
        value: "second_service_name",
        available: true,
      },
      { text: this.$t("status"), value: "status", available: true },
      {
        text: this.$t("quantity"),
        value: "quality",
        align: "center",
        left: true,
        available: true,
      },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.sourse_store = this.stores[0];
    this.destination_store = this.stores[0];
  },
  watch: {
    status: {
      deep: true,
      handler() {
        this.update_transfers();
      },
    },
    sourse_store: {
      deep: true,
      handler() {
        this.update_transfers();
      },
    },
    destination_store: {
      deep: true,
      handler() {
        this.update_transfers();
      },
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>